import {IconsObject} from '@/icons/services/IconService';

const assignmentExtensions: IconsObject = {
  searchForUser: 'mdi-account-search-outline',
};

export default assignmentExtensions;
